import { render, staticRenderFns } from "./quotationImg.vue?vue&type=template&id=bba5bc6c&scoped=true&"
import script from "./quotationImg.vue?vue&type=script&lang=js&"
export * from "./quotationImg.vue?vue&type=script&lang=js&"
import style0 from "./quotationImg.vue?vue&type=style&index=0&id=bba5bc6c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bba5bc6c",
  null
  
)

export default component.exports